<template>
  <div id="OrgDetailAptitude">
    <eb-panel>
      <eb-panel-header class="panel-header" slot="header">
        <span slot="title">企业资质</span>
      </eb-panel-header>
      <div slot="body">
        <div class="panel-body-row" v-for="aptitudeFile in orgAptitudeFileArr" :key="aptitudeFile.fileId">
        <div class="panel-body-row-left" style="width: 100%;">
          <ul class="aptitudeFileShowArea">
            <li style="width:100px;height:100px;">
              {{aptitudeFile.fileDesc}}
            </li>
            <li>
              <div class="aptitude-img-file" v-image-preview :data-img-preview-src="getFilePath(aptitudeFile.filePath)" :style="'backgroundImage:url(' + getFilePath(aptitudeFile.filePath) +');cursor: pointer;'"></div>
            </li>
            <li>
              <i title="删除" style="color: red;cursor: pointer;" class="iconfont icon-shanchu" @click="confirmDelOrgAptitudeFile(aptitudeFile)"></i>
            </li>
            <li>
              <i title="上传" style="color: red;cursor: pointer;" class="icon iconfont icon-ico_pic" @click="showEditOrgAptitudeWindow(aptitudeFile)"></i>
            </li>
          </ul>
        </div>
      </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left projectInfo">
            <a class="cursor" @click="showAddOrgAptitudeWindow()" style="color: red; font-weight: bold;cursor: pointer;">添加+</a>
          </div>
        </div>
      </div>
    </eb-panel>
  </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
import { deleteDepartFile } from '@/services/org/depart-service';
import { imagePreview } from '@/directives/image-preview';
import eventBus from '@/plugins/event-bus';
import { baseURL } from '@/plugins/axios.js';

export default {
  name: 'OrgDetailInfo',
  directives: {
    imagePreview: imagePreview
  },
  components: {
    ebPanel,
    ebPanelHeader
  },
  props: {
    orgAptitudeFileArr: {
      type: Array
    }
  },
  methods: {
    getFilePath(filePath) {
      return filePath ? baseURL + filePath : baseURL + '/static/img/147x147.png';
    },
    confirmDelOrgAptitudeFile(aptitudeFile) {
      this.$confirm('确认删除么？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'eb-confirm-button',
        cancelButtonClass: 'eb-confirm-button',
        type: '',
        center: true,
        showClose: false,
        customClass: 'eb-comfirm'
      })
        .then(() => {
          var params = {
            fileId: aptitudeFile.fileId
          };
          this.delOrgAptitudeFile(params);
        })
        .catch(() => {});
    },
    async delOrgAptitudeFile(params) {
      try {
        let result = await deleteDepartFile(params);
        result = result.data;
        if (result.returnCode === '01') {
          this.$message.success('删除资质文件成功');
          this.$emit('refreshOrgAptitudeFile');
        } else {
          this.$message.error('删除资质文件失败！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    showAddOrgAptitudeWindow() {
      eventBus.$emit('showAddOrgAptitudeWindow', '');
    },
    showEditOrgAptitudeWindow(aptitudeFile) {
      eventBus.$emit('showEditOrgAptitudeWindow', aptitudeFile);
    }
  }
};
</script>
<style lang="less">
  #OrgDetailAptitude {
    ul, li {
      list-style: none;
    }

    .aptitudeFileShowArea li {
      line-height: 100px;
      float: left;
      vertical-align: bottom;
      margin-right: 5px;
    }
    .aptitude-img-file {
      width: 100px;
      height: 100px;
      border: 1px solid #CCCCCC;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }
</style>
